// This file contains the cart object, all methods and properties

const cart = {
  elem: document.getElementById('dynamic-cart'),
  navIcon: document.getElementById('cart-btn'),
  data: {},
  isOpen: false,
  notesOpen: false,
  config: {
    drawerSlideInTime: 400,
    drawerSlideOutTime: 300,
    packagingImagesLoaded: false,
    openOnAddToBag: true,
    openOnAddToBagDelay: 1000,
    notesInitialHeight: 90,
    availabilityStatusProp: true
  },
  helpers: {}
  //useOffers: false,
  //removeOldOffers: true, // Remove offers from carts if useOffers is false
  // offers: {
  //   eligibleCollectionHandle: 'mothers-day-offer',
  //   eligibleProductIDs: [],
  //   giftProductHandle: 'mothers-day-gift-coin',
  //   tiers: [
  //     { minSpend: 489, maxSpend: 988 },
  //     { minSpend: 989, maxSpend: 1488 },
  //     { minSpend: 1489, maxSpend: 1988 },
  //     { minSpend: 1989, maxSpend: 2488 },
  //     { minSpend: 2489, maxSpend: 2988 },
  //     { minSpend: 2989, maxSpend: 3488 },
  //     { minSpend: 3489, maxSpend: 3988 },
  //     { minSpend: 3989, maxSpend: 4488 },
  //     { minSpend: 4489, maxSpend: 4988 },
  //     { minSpend: 4989, maxSpend: 5488 }
  //   ]
  // }
}

/*
// Convert Mother's Day spending brackets for alt currencies (temp)
if (cart.offers.tiers && Shopify.currency.active !== 'EUR') {
  cart.offers.tiers.forEach(tier => {
    tier.minSpend = parseFloat((tier.minSpend * Shopify.currency.rate).toFixed(2));
    tier.maxSpend = parseFloat((tier.maxSpend * Shopify.currency.rate).toFixed(2));
  });
}
*/

// The idea here is to use cart.data to store the contents of /cart.json.
// If you change something in cart.json, you get the updated data returned to you.
// At the end of methods, save this updated data to cart.data so you can use it
// in the next method with confidence that it's up-to-date

// Convenience function for repeated Fetch Posting
cart.helpers.fetchPost = (url, data) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(r => {
        if (!r.ok) {
          reject(r)
        } else {
          return r
        }
      })
      .then(r => resolve(r.json()))
      .catch(err => reject(err))
  })
}

cart.helpers.slideToggle = (targetElem, initialHeight, seconds) => {
  targetElem.style.transition = `height ${seconds}s ease-in-out`
  if (targetElem.offsetHeight > 0) {
    // Close
    targetElem.style.height = `${targetElem.offsetHeight}px`
    targetElem.style.overflow = `hidden`
    window.setTimeout(() => (targetElem.style.height = '0px'), 1)
    window.setTimeout(() => {
      targetElem.style.display = 'none'
    }, seconds * 1000)
  } else {
    // Open
    targetElem.style.display = 'block'
    targetElem.style.overflow = `hidden`
    targetElem.style.height = '0px'
    window.setTimeout(() => (targetElem.style.height = `${initialHeight}px`), 1)
    window.setTimeout(() => {
      targetElem.style.height = 'auto'
      targetElem.style.overflow = `visible`
    }, seconds * 1000)
  }
}

// Update cart JSON
cart.updateData = () => {
  // Pulls cart.json into the data attribute
  return new Promise((resolve, reject) => {
    fetch('/cart.json')
      .then(d => d.json())
      .then(d => {
        cart.data = d
        resolve(d)
      })
      .catch(err => reject(err))
  })
}

// This function is for event listeners within a line item element
// Since elements are deleted and re-rendered, we need to re-add them on render.
cart.registerItemListeners = (lineItemElement, lineItem) => {
  // Quantity select
  const quantitySelect = lineItemElement.querySelector('.qty select')
  if(quantitySelect) {
    quantitySelect.onchange = () => {
      cart.updateItemQuantity(lineItem, parseInt(quantitySelect.value, 10), true)
    }
  }

  // Remove Items
  const removeBtn = lineItemElement.querySelector('.remove')
  removeBtn.onclick = () => {
    cart.remove(lineItem)
  }

}

// Render Cart with data
// Updates front end with the cart.data object
cart.render = () => {

  // List of property notes
  const detailNoteKeys = [
    'Size',
    'Chain size',
    'Bracelet size',
    'Initials',
    'Number of discs',
    'Engraving',
    'Coordinates',
    'Birthstone',
    'Starsign',
    'Zodiac',
    'Stones',
    'Diamonds',
    'Amount',
    'Notebook',
    'Event time',
    'Added to',
    'Upgrades'
  ]
  // Remove non-template items
  const lineItems = cart.elem.querySelectorAll('.drawer-main ul li')
  lineItems.forEach(node => {
    // Don't delete the template
    if (node.classList.contains('cart-item-template') === false) {
      node.parentNode.removeChild(node)
    }
  })

  const setCartAsEmpty = () => {
    // Show the empty message
    cart.elem.querySelector('.drawer-main .cart-empty').style.display = 'block'
    // Hide the footer
    cart.elem.querySelector('.drawer-footer').style.display = 'none'
    // Reset the cart button
    cart.navIcon.classList.remove('active')
    // Delete the cart note highlight cookie
    setCookie('cart-note-highlight', 'false', 0)
    // Update cart attributes as null
    cart.updateAttributes({
      order_estimated_shipping: null, 
      bespoke_sizes: null,
      upgrades: null,
      engravings: null
    });
  }

  // If cart.data is empty
  if (cart.data.item_count === 0) {
    setCartAsEmpty();
    return cart // End the function
  }

  /*
  // If only item in cart is Mother's Day gift product (temp)
  if(document.body.getAttribute('data-mothers-day-offer') == 'true') {
    if(cart.data.item_count === 1 && cart.data.items[0].handle == cart.offers.giftProductHandle) {
      setCartAsEmpty();
      mothersDayOffer();
      return cart // End the function
    }
  }
  */

  // If cart is not empty

  // Hide the empty message
  cart.elem.querySelector('.drawer-main .cart-empty').style.display = 'none'

  // This is an empty cart item that we can clone and populate
  const templateItem = cart.elem.querySelector(
    '.drawer-main ul li.cart-item-template'
  )

  // Main render loop
  cart.data.items.forEach(item => {

    /*
    // Do not render Mother's Day gift product (temp)
    if(document.body.getAttribute('data-mothers-day-offer') == 'true') {
      if(item.handle == cart.offers.giftProductHandle) {
        return;
      }
    }
    */

    const index = cart.data.items.indexOf(item)
    // This is the line item number in the cart, which is 1-indexed.
    // We're adding an additional 1 to skip the cart template item
    const line = index + 1
    // Replace the first character with current currency symbol
    const currencySymbol = document.body.getAttribute('data-currency-symbol')
    const { active: currency } = Shopify.currency
    let thisItemPriceFormatted = Shopify.formatMoney(item.price).replace(
      /^.{1}/g,
      currencySymbol
    );
    thisItemPriceFormatted = thisItemPriceFormatted.replace('.00', ''); // remove decimal
    // Trim from decimal if currency is Japanese Yen
    if (currency === 'JPY') {
      thisItemPriceFormatted = thisItemPriceFormatted.split('.00')[0];
    }

    // Clone the template
    const newItem = templateItem.cloneNode(true)
    newItem.classList.remove('cart-item-template')

    // Attach item data
    newItem.setAttribute('data-product-id', item.product_id);
    newItem.setAttribute('data-variant-id', item.variant_id);

    // Populate the clone
    
    // Set the image after resize
    const imageSize = '160x160'
    let cartThumbnail = item.image
    if(cartThumbnail) {
      if (cartThumbnail.indexOf('.jpg') !== -1) {
        cartThumbnail = cartThumbnail.replace('.jpg', `_${imageSize}.jpg`)
      } else if (cartThumbnail.indexOf('.png') !== -1) {
        cartThumbnail = cartThumbnail.replace('.png', `_${imageSize}.png`)
      }
      newItem.querySelector('img').src = cartThumbnail
      newItem.querySelector('img').alt = item.product_title
      newItem.querySelector('img').parentNode.setAttribute('href', item.url)
    }

    // Set the title
    const titleElem = newItem.querySelector('.title');
    titleElem.setAttribute('href', item.url);
    titleElem.children[0].innerHTML = item.product_title.replace('- ', '<span>') + '</span>';

    // Set selected variant and detail notes
    if(item.variant_title) {
      newItem.querySelector('.detail-notes').innerHTML += `<span class="detail-note">${item.variant_title}</span>`;
    }
    if (item.properties) {
      // for (const [key, value] of Object.entries(item.properties)) {
      //   // If the key is in the list of keys to show, show it
      //   if (detailNoteKeys.includes(key)) {
      //     newItem.querySelector('.detail-notes').innerHTML += `<span class="detail-note">${key}: ${value}</span>`;
      //   }
      // }
      detailNoteKeys.forEach((detailNoteKey) => {
        if(Object.keys(item.properties).includes(detailNoteKey)) {
          newItem.querySelector('.detail-notes').innerHTML += `<span class="detail-note">${detailNoteKey}: ${item.properties[detailNoteKey]}</span>`;
        }
      });
    }

    // Quantity (exclude on upgrades)
    if (item.properties['_added_to']) {
      newItem.querySelector('.qty').remove();
    } else {
      newItem.querySelector('.qty select').value = item.quantity
    }
    // Price
    newItem.querySelector('.price').textContent = thisItemPriceFormatted

    // Check for compare price (compare_at_price not included in cart endpoint, need to fetch product JSON)
    fetch(`/products/${item.handle}.json`)
    .then(response => response.json())
    .then(data => {
      // Get matching variant
      let variant = data.product.variants.find(o => o.id === item.variant_id);
      let compareAtPrice = variant.compare_at_price;
      // If variant has compare price, add it to the cart item
      if (compareAtPrice !== null && compareAtPrice !== ''){
        // Format compare price with symbol + commas
        compareAtPrice = currencySymbol + compareAtPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // Remove decimal
        compareAtPrice = compareAtPrice.replace('.00', '');
        // Format for JPY
        compareAtPrice = currency === 'JPY' ? compareAtPrice.split('.')[0] : compareAtPrice;
        // Add compare price
        let originalPriceElement = document.createElement('span');
        originalPriceElement.innerText = `${compareAtPrice}`;
        newItem.querySelector('.price').prepend(originalPriceElement);
        newItem.querySelector('.price').classList.add('sale');
      }
    });

    // Append the item to the list
    cart.elem.querySelector('.drawer-main ul').appendChild(newItem)

    // Register event listeners
    cart.registerItemListeners(newItem, item)

  }) // End of the items loop


  // Remove any Gift Coin cart items for non-EUR currencies
  if(cart.data.currency !== 'EUR' && cart.data.items.some(item => item.handle == 'chupi-gift-coin')) {
    cart.data.items.forEach((item) => {
      if(item.handle == 'chupi-gift-coin') {
        cart.remove(item);
      }
    });
    console.log('Gift Coins removed for non-EUR currencies');
  }


  // Show cart footer
  cart.elem.querySelector('.drawer-footer').style.display = 'block'
  // Update Estimated Shipping time
  let cartShippingETA = getCartShippingETA(cart.data.items);
  if(cartShippingETA == null) {
    cart.elem.querySelector('.cart-shipping').style.display = 'none';
  } else {
    cart.elem.querySelector('#cart-estimated-shipping').innerText = cartShippingETA;
    cart.elem.querySelector('.cart-shipping').style.display = 'block';
  }
  // Update bespoke sizes, upgrades and engravings for cart attributes
  let bespokeSizeList = '', upgradesList = '', engravingsList = '';
  let bespokeItemCount = 0, upgradeCount = 0, engravingsCount = 0;
  cart.data.items.forEach(item => {
    // Bespoke sizes list
    if(item.variant_title && item.variant_title.toLowerCase().includes('bespoke')) {
      bespokeItemCount += 1;
      if (bespokeItemCount > 1) { bespokeSizeList += ' | '; } // append separator
      bespokeSizeList += `${item.sku}: ${item.properties['Size'].replace(' - MADE TO ORDER', '').trim()}`;
    }
    // Upgrades list
    if(item.properties['Upgrades']) {
      upgradeCount += 1;
      if (upgradeCount > 1) { upgradesList += ' | '; } // append separator
      upgradesList += `${item.sku}: ${item.properties['Upgrades']}`;
    }
    // Engravings list
    if(item.properties['Engraving']) {
      engravingsCount += 1;
      if (engravingsCount > 1) { engravingsList += ' | '; } // append separator
      engravingsList += `${item.sku}: ${item.properties['Engraving']}`;
    }
  });
  // Update cart total (remove decimal)
  cart.elem.querySelector('#cart-total-price').textContent = makeCurrency((cart.data.total_price/100).toFixed(2).replace('.00', ''), true);
  // Update the note
  if (cart.data.note !== null && cart.data.note.length > 0) {
    cart.elem.querySelector('.add-note-btn').textContent = 'Edit note'
  } else {
    cart.elem.querySelector('.add-note-btn').textContent =
      'Add a note for someone special'
  }
  cart.elem.querySelector('#note').value = cart.data.note
  // Remove the loading class
  cart.elem.classList.remove('loading')

  // Add an active class to cart btn
  cart.navIcon.classList.add('active')

  // Update checkout prompt overlay
  if(document.getElementById('checkout-prompt-overlay')) {
    updateCheckoutPrompt(cart.data.item_count);
  }

  // Update cart attributes
  cart.updateAttributes({
    order_estimated_shipping: cartShippingETA,
    bespoke_sizes: bespokeSizeList,
    upgrades: upgradesList,
    engravings: engravingsList
  });

  /*
  // Apply Mother's Day offer if offer is active
  if(document.body.getAttribute('data-mothers-day-offer') == 'true') {
    mothersDayOffer();
  }
  */

} // End of cart.render()


/*
// Mother's Day Offer (temp)
const mothersDayOffer = () => {

  let applyMothersDayOffer = async () => {

    try {

      // Fetch Gift Product data
      let giftProduct = await fetch(`/products/${cart.offers.giftProductHandle}.js`).then(res => res.json());
      giftProduct.variants.forEach((variant, i) => {
        cart.offers.tiers[i].giftVariantID = variant.id;
        cart.offers.tiers[i].giftVariantTitle = variant.title;
      })

      // Remove existing gift product from cart
      let giftProductCartItem = cart.data.items.find(item => item.handle == cart.offers.giftProductHandle);
      if (giftProductCartItem) {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftProductCartItem.key, quantity: 0 })
        });
        cart.data = await fetch('/cart.js').then(res => res.json());
        // console.log(cart.data.items);
      }

      // Fetch MD collection and push product IDs to array for validation check later on
      let eligibleCollection = await fetch(`/collections/${cart.offers.eligibleCollectionHandle}/products.json?limit=250`).then(res => res.json());
      eligibleCollection.products.forEach(product => {
        cart.offers.eligibleProductIDs.push(product.id)
      });

      // Get eligible total
      let eligibleItemsTotal = 0;
      cart.data.items.forEach(item => {
        if (cart.offers.eligibleProductIDs.includes(item.product_id)) {
          eligibleItemsTotal += (item.price/100) * item.quantity;
        }
      });
      console.log(`Total eligible Mother's Day offer spend: ${eligibleItemsTotal}`);

      // Find gift value
      cart.offers.eligibleTier = null; // reset
      for (let i = 0; i < cart.offers.tiers.length; i++) {
        if (eligibleItemsTotal >= cart.offers.tiers[i].minSpend && eligibleItemsTotal <= cart.offers.tiers[i].maxSpend) {
          cart.offers.eligibleTier = cart.offers.tiers[i];
          break;
        }
      }
      // If spend exceeds tiers, cap at last tier
      if (eligibleItemsTotal > cart.offers.tiers[cart.offers.tiers.length - 1].maxSpend) {
        cart.offers.eligibleTier = cart.offers.tiers[cart.offers.tiers.length - 1];
      }

      // Add gift product to cart
      if(cart.offers.eligibleTier) {
        console.log(`Eligible for: ${cart.offers.eligibleTier.giftVariantTitle}`);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              id: cart.offers.eligibleTier.giftVariantID,
              quantity: 1
          })
        });
        cart.data = await fetch('/cart.js').then(res => res.json());
        // console.log(cart.data.items);
        // Add as cart element
        let giftProductElem = document.createElement('li');
        giftProductElem.classList.add('cart-item', 'promotional-gift-coin', 'loading');
        giftProductElem.innerHTML = `
          <a href="${`/collections/${cart.offers.eligibleCollectionHandle}`}" target="_blank">
            <div class="inner">
              <h3>${giftProduct.title}<span>${cart.offers.eligibleTier.giftVariantTitle}</span></h3>
              <span class="info-btn"></span>
            </div>
          </a>
        `;
        cart.elem.querySelector('.drawer-main ul').appendChild(giftProductElem);
        setTimeout(() => {
          giftProductElem.classList.remove('loading');
        }, 50);

      }

    } catch (error) {
      console.error('Error updating cart:', error);
    }

  }
  applyMothersDayOffer();

} // mothersDayOffer()
*/








// Convenience function to update the cart data and render
cart.refresh = () => cart.updateData().then(() => cart.render())

// Open Cart
cart.open = () => {
  cart.isOpen = true
  cart.elem.classList.add('active')
  cart.elem.querySelector('.drawer-header .close-btn').classList.add('highlight')
  handleFixedElements('hide');
  setTimeout(() => {
    // Check for note highlight cookie and pop the note open if it's not there
    const noteHighlightCookieExists =
      getCookie('cart-note-highlight').length > 0
    if (
      !noteHighlightCookieExists &&
      (cart.data.note === null || cart.data.note.length === 0)
    ) {
      const noteButton = cart.elem.querySelector('.add-note-btn')
      const notesWrapper = cart.elem.querySelector('.notes-wrapper')
      const notesInitialHeight = parseInt(
        window.getComputedStyle(note).getPropertyValue('height'),
        10
      )
      if (!cart.notesOpen) {
        cart.helpers.slideToggle(notesWrapper, notesInitialHeight, 0.2)
        noteButton.classList.add('active')
        cart.notesOpen = true
        window.setTimeout(() => notesWrapper.classList.add('active'), 200)
        setCookie('cart-note-highlight', 'seen', 30)
      }
    }
  }, cart.config.drawerSlideInTime)
}

// Close Cart
cart.close = () => {
  cart.elem.classList.remove('active')
  cart.isOpen = false
  handleFixedElements('show');
}

// Change item quantity in cart.json
cart.updateItemQuantity = (lineItem, quantity, refresh) => {
  cart.elem.classList.add('loading')
  // cart.elem.classList.add('loading');
  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/change.js', {
        id: lineItem.key,
        quantity: quantity
      })
      .then(r => {
        cart.elem.classList.remove('loading')
        // Update data
        cart.data = r
        if (refresh) cart.render()
        resolve(r)
      })
      .catch(err => {
        cart.elem.classList.remove('loading')
        if (refresh) cart.render()
        reject(err)
        // Append quantity error to this cart item
        let quantityErrorMessage = 'The selected quantity could not be applied due to limited stock of this item.'
        if (lineItem.product_type == 'Event') {
          quantityErrorMessage = 'The selected quantity could not be applied due to limited places for this event.'
        }
        let cartElem = cart.elem.querySelector(`[data-variant-id='${lineItem.variant_id}']`);
        let quantityError = document.createElement('span');
        quantityError.classList.add('error-message');
        quantityError.innerText = quantityErrorMessage;
        cartElem.querySelector('.inner div:nth-of-type(2)').append(quantityError);
      })
  })
}


// Add a variant ID to cart
cart.add = (variantId, quantity, props, refresh) => {
  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/add.js', {
        id: variantId.toString(),
        quantity: quantity,
        properties: props || {}
      })
      .then(r => {
        cart.elem.classList.remove('loading')
        // We don't update data here because it returns the new line item
        if (refresh) cart.refresh()
        resolve(r)
      })
      .catch(err => {
        cart.elem.classList.remove('loading')
        reject(err)
      })
  })
}


// Add multiple items to cart
// (where items is an array of objects in the form {id: variantId, quantity: 1, properties: props})
cart.addMultiple = (items, refresh) => {
  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/add.js', {'items': items})
      .then(r => {
        cart.elem.classList.remove('loading')
        // We don't update data here because it returns the new line item
        if (refresh) cart.refresh()
        resolve(r)
      })
      .catch(err => {
        cart.elem.classList.remove('loading')
        reject(err)
      })
  })
}


// Remove items from cart.json using line item
cart.remove = lineItem => {

  cart.elem.classList.add('loading');
  let itemsToRemove = [lineItem]; // Add lineItem to itemsToRemove array

  // Check for add-ons on this item
  let addOnParentTitle = lineItem.product_title;
  if (lineItem.properties['Initials']) {
    addOnParentTitle += ` (${lineItem.properties['Initials']})`; // append initials
  }
  cart.data.items.forEach(item => {
    if(item.properties['Added to'] == addOnParentTitle) {
      itemsToRemove.push(item);
    }
  })

  // Check for upgrades on this item
  if(lineItem.properties['Upgrades']) {
    lineItem.properties['Upgrades'].split(', ').forEach(upgradeVariantTitle => {
      cart.data.items.forEach(item => {
        if(item.variant_title == upgradeVariantTitle) {
          itemsToRemove.push(item);
        }
      })
    });
  }

  // Create object of items to be removed to pass to /cart/update.js
  let itemsToRemoveObj = {};
  itemsToRemove.forEach(item => itemsToRemoveObj[item.key] = 0 ); // items must be identified by unique 'key' property

  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/update.js', { updates: itemsToRemoveObj })
      .then(r => {
        cart.elem.classList.remove('loading');
        // Apply remove animation to each removed item
        itemsToRemove.forEach(item => {
          let itemElem = cart.elem.querySelector(`[data-variant-id='${item.variant_id}']`);
          itemElem.classList.add('removed')
          itemElem.style.height = `${itemElem.offsetHeight}px`
          itemElem.style.overflow = 'hidden'
          window.setTimeout(() => {
            itemElem.style.height = '0px'
          }, 200)
        });
        // Check if original removed item was upgrade to modify 'Upgrades' prop on parent
        if (lineItem.properties['_added_to']) {
          cart.data.items.forEach(item => {
            // Find parent item
            if(lineItem.properties['_added_to'] == `${item.product_title} - ${item.variant_title}`) {
              if(item.properties['Upgrades']) {
                // Remove from upgrade from Upgrades props
                let upgrades = item.properties['Upgrades'].split(', ');
                upgrades = upgrades.filter(item => item !== lineItem.variant_title); // remove upgrade
                if(upgrades.length) {
                  item.properties['Upgrades'] = upgrades.join(", ");
                } else {
                  delete item.properties['Upgrades']; // remove Upgrades prop entirely
                }
                // Update Upgrades props on parent item
                cart.updateItemProperties(item, item.properties, true);
              }
            }
          });
        }
        else {
          cart.data = r; // Update data
          window.setTimeout(() => cart.render(), 600); // Re-render after animation
        }
        resolve(r);
      })
      .catch(err => {
        cart.elem.classList.remove('loading');
        reject(err);
      })
  });

}


// Change item properties in cart.json
// This does not replace props, but instead updates values of what's there already.
// If you want to delete a prop, pass null as the value for the key
cart.updateItemProperties = (lineItem, props, refresh) => {
  cart.elem.classList.add('loading')
  const { properties: existingProps } = lineItem
  const newProps = { ...existingProps, ...props }
  if (typeof newProps !== 'object') {
    return
  }
  // Loop through the new props and delete any null
  for (const [key, value] of Object.entries(newProps)) {
    // Delete if null
    if (value === null) {
      delete newProps[key]
    }
  }
  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/change.js', {
        id: lineItem.key,
        quantity: lineItem.quantity,
        properties: newProps
      })
      .then(r => {
        // Update data
        cart.data = r
        if (refresh) cart.render()
        cart.elem.classList.remove('loading')
        resolve(r)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// Edit note on cart.json
cart.updateNote = text => {
  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/update.js', {
        note: text
      })
      .then(r => {
        cart.data = r
        resolve(r)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// Edit cart.json attributes
cart.updateAttributes = (newAttributes, refresh) => {
  const { attributes: existingAtts } = cart.data
  const newAtts = { ...existingAtts, ...newAttributes }
  // Loop through the new props and delete any null
  for (const [key, value] of Object.entries(newAtts)) {
    // Delete if null
    if (value === null) {
      delete newAtts[key]
    }
  }
  return new Promise((resolve, reject) => {
    cart.helpers
      .fetchPost('/cart/update.js', {
        attributes: newAttributes
      })
      .then(r => {
        // Update data
        cart.data = r
        if (refresh) cart.render()
        resolve(r)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// Clear cart
cart.clear = refresh => {
  return new Promise((resolve, reject) => {
    fetch('/cart/clear.js')
      .then(() => {
        if (refresh) {
          cart.refresh()
          resolve()
        }
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}

// Event listeners, front end controls etc.

function cartExternalTriggers () {
  // Open
  cart.navIcon.addEventListener('click', e => {
    e.preventDefault()
    cart.open()
  })
  // Close
  cart.elem.querySelector('.drawer-back').onclick = () => cart.close()
  cart.elem.querySelector('.close-btn').onclick = () => cart.close()

  // Open on add to bag
  // MOVED TO PRODUCT ADD TO BAG

  // Open on add to bag direct
  // MOVED TO PRODUCT ADD TO BAG

  // Open note
  const note = cart.elem.querySelector('#note')
  const noteButton = cart.elem.querySelector('.add-note-btn')
  const notesWrapper = cart.elem.querySelector('.notes-wrapper')
  // Pull the intial notes height from the computed style (css)
  const notesInitialHeight = parseInt(
    window.getComputedStyle(note).getPropertyValue('height'),
    10
  )
  noteButton.onclick = () => {
    cart.helpers.slideToggle(notesWrapper, notesInitialHeight, 0.2)
    if (cart.notesOpen) {
      // If open, close
      notesWrapper.classList.remove('active')
      noteButton.classList.remove('active')
    } else {
      // If closed, open
      noteButton.classList.add('active')
      // Wait until slide up is finished to show note progress
      window.setTimeout(() => notesWrapper.classList.add('active'), 200)
    }
    cart.notesOpen = !cart.notesOpen
  }

  // Edit note
  note.onchange = () => {
    cart.updateNote(note.value)
  }

  // Animate the max characters progress
  // Flag any notes with things like "size" etc.
  const progressWrapper = cart.elem.querySelector('.additional-notes-progress')
  const progressElement = cart.elem.querySelector('.progress-radial__value')
  const r = progressElement.getAttribute('r')
  const circ = 2 * Math.PI * r
  const maxLength = note.getAttribute('maxlength')
  const bespokeTerms = [
    'size',
    'length',
    'resize',
    'white gold',
    'rose gold',
    'diamond',
    'grey'
  ]
  const notePrompt = cart.elem.querySelector('.note-prompt')
  note.onkeyup = () => {
    // Update the progress
    const percentageOfMax = note.value.length / maxLength
    const dashOffset = circ * (1 - percentageOfMax)
    progressElement.style.strokeDashoffset = dashOffset
    if (percentageOfMax === 1) {
      progressWrapper.classList.add('limit-reached')
      progressWrapper.classList.add('progress-warning')
    } else if (percentageOfMax > 0.95 && percentageOfMax != 1) {
      progressWrapper.classList.remove('limit-reached')
      progressWrapper.classList.add('progress-warning')
    } else if (percentageOfMax > 0.95) {
      progressWrapper.classList.add('progress-warning')
    } else {
      progressWrapper.classList.remove('progress-warning')
      progressWrapper.classList.remove('limit-reached')
    }

    // Check for bespoke terms
    if (bespokeTerms.some(t => note.value.indexOf(t) !== -1)) {
      // at least one term is used
      notePrompt.classList.add('active')
    } else {
      // No terms used
      notePrompt.classList.remove('active')
    }
  }

  // Empty bag using Konami
  const konamiEmptyBag = [
    'up',
    'up',
    'down',
    'down',
    'left',
    'right',
    'left',
    'right',
    'b',
    'r',
    'o',
    'k',
    'e'
  ]
  doCustomKonamiCode(konamiEmptyBag, () => {
    cart.clear(true).then(() => cart.open())
  })
}

window.addEventListener('load', () => {
  //cart.helpers.captureEarlyAccess(cart.offers.earlyAccessParam)
  cart.refresh().then(() => {
    cartExternalTriggers()
    if (window.location.search.indexOf('cart=open') !== -1) {
      cart.open()
    }
  });
});

